class SNSShare {
    constructor() {
        Kakao.init('445b4ba46d4782f6b84dafa109fc124f');

        Kakao.Link.createDefaultButton({
            container: '#share-kakao',
            objectType: 'feed',
            content: {
            title: document.querySelector("meta[property='og:title']").getAttribute("content"),
            description: document.querySelector("meta[property='og:description']").getAttribute("content"),
            imageUrl:
                document.querySelector("meta[property='og:image']").getAttribute("content"),
            link: {
                // mobileWebUrl: location.href,
                // webUrl: location.href,
                mobileWebUrl: 'https://10th.rootimpact.org/',
                webUrl: 'https://10th.rootimpact.org/',
            },
            },
            buttons: [
            {
                title: '웹으로 보기',
                link: {
                // mobileWebUrl: location.href,
                // webUrl: location.href,
                mobileWebUrl: 'https://10th.rootimpact.org/',
                webUrl: 'https://10th.rootimpact.org/',
                },
            }
            ],
        })
    }
}

export default SNSShare;